import React from "react";
import { Route } from "react-router-dom";
import Seo from "../../../common/helpers/seo";

import routing from "../../routing";
import { StyledTranslations } from "./styles";
import LanguageSelector from "./LanguageSelector";
import LanguagePage from "./LanguagePage";

const Translation = () => (
    <StyledTranslations>
        <Seo title="Translation" noindex nofollow />
        <Route path={`/${routing.translate}`} exact component={LanguageSelector} />
        <Route path={`/${routing.translate}/:language`} exact component={LanguagePage} />
    </StyledTranslations>
);

export default Translation;
